import { add, format, isWeekend } from 'date-fns';
import { isHoliday } from 'date-fns-holiday-us';

export default function GetPolicyEffectiveDate(initialDraftDate) {

  let date = add(initialDraftDate, { days: 14 });

  while (isWeekend(date) || isHoliday(date)) {
    date = add(date, { days: 1 });
  }

  return format(date, 'MM/dd/yyyy');
}
